import { toastManager } from '@crm/entities/toast';
import { resolveApiError } from '@crm/shared/api';
import { mapApiFieldErrors } from '@crm/shared/lib';

const fieldByPointer = { name: 'name' } as const;

export const handleTitleUpdateError = (error: unknown, fallback: string): string | undefined => {
    const resolvedError = resolveApiError(error, fallback);

    if (resolvedError.type === 'toast') {
        toastManager.onError({ title: resolvedError.message });
        return undefined;
    }

    const mappedErrors = mapApiFieldErrors(resolvedError.errors, fieldByPointer);

    if (!mappedErrors) {
        toastManager.onError({ title: resolvedError.summary });
        return undefined;
    }

    return mappedErrors[0]?.message;
};
